export function pageFeedback() {
    return {
        rating: 0,
        hoverRating: 0,
        showForm: false,
        selectedReason: '',
        loading: false,
        showThankYou: false,

        setRating(val) {
            this.rating = val;
            this.showForm = true;
        },

        selectReason(reason) {
            this.selectedReason = reason;
        },

        cancel() {
            this.showForm = false;
            this.selectedReason = '';
        },

        async submit() {
            if (!this.rating && !this.selectedReason) return;
            this.loading = true;

            const payload = { page_url: window.location.href };
            if (this.rating) payload.rating = this.rating;
            if (this.selectedReason) payload.reason = this.selectedReason;

            try {
                const response = await fetch(window.location.href, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(payload),
                });
                if (!response.ok) throw new Error('Server error');
                await response.json();
                this.showThankYou = true;
            } catch (_) {
                this.showThankYou = true;
            } finally {
                this.loading = false;
            }
        },
    };
}

export function registerPageFeedback(Alpine) {
    Alpine.data('pageFeedback', pageFeedback);
}
